module.exports = __webpack_public_path__ + "ce10d2e6058755c4c50198c2ec58a505.pdf";